import { useCallback } from 'react';

import { AccountManager } from '@atlas/core';

import { POSTHOG_CTA } from 'common/constants';

const getNextStepCta = isFirstStep => (isFirstStep ? null : POSTHOG_CTA.NEXT_STEP);
const isLastStepNotFirst = (isMultiStepFlow, isLastStep, isFirstStep) =>
  isMultiStepFlow && isLastStep && !isFirstStep;

const getSubmitAction = (isMultiStepFlow, isFirstStep, isLastStep, submit, stepSubmit) => {
  let submitAction;
  if (isMultiStepFlow) {
    submitAction = isFirstStep ? submit : stepSubmit;
  } else if (isLastStep) {
    submitAction = submit;
  }
  return submitAction;
};

const useSignUpAction = ({
  isMultiStepFlow,
  submit,
  stepSubmit,
  isFirstStep,
  isLastStep,
  setActiveStep,
  activeStep,
  redirectAfterRegistration,
  leaveAfterFirstStep,
  useWindowRedirect = false,
  onNextStep,
  resetActiveForm,
}) =>
  useCallback(
    async (...args) => {
      const submitAction = getSubmitAction(
        isMultiStepFlow,
        isFirstStep,
        isLastStep,
        submit,
        stepSubmit,
      );

      try {
        if (submitAction) {
          await submitAction(...args);

          if (isMultiStepFlow && !isLastStep) {
            onNextStep?.(getNextStepCta(isFirstStep));
            await resetActiveForm();
          }
        }

        const isMultiStepFirstStepExit = isMultiStepFlow && isFirstStep && leaveAfterFirstStep;

        if (isMultiStepFirstStepExit) {
          await AccountManager.resolveAuthentication();

          if (useWindowRedirect) {
            window.location.replace('/');
          } else {
            redirectAfterRegistration();
          }

          return;
        }

        if (isLastStep) {
          if (isLastStepNotFirst(isMultiStepFlow, isLastStep, isFirstStep)) {
            onNextStep?.(POSTHOG_CTA.NEXT_STEP, true);
          }
          await AccountManager.resolveAuthentication();
          redirectAfterRegistration();
          return;
        }

        if (!isMultiStepFlow) {
          // email hashing will be implement in FT-7781
          onNextStep?.(POSTHOG_CTA.NEXT_STEP, false, args[0]?.EMAIL);
          setActiveStep(activeStep + 1);
        }
      } catch (error) {
        console.error('Error during registration: ', error);
      }
    },
    [
      isMultiStepFlow,
      submit,
      stepSubmit,
      isFirstStep,
      isLastStep,
      setActiveStep,
      activeStep,
      redirectAfterRegistration,
      leaveAfterFirstStep,
      useWindowRedirect,
      onNextStep,
      resetActiveForm,
    ],
  );

export default useSignUpAction;
